import type { Pagination } from 'models';
import { useEffect, useState } from 'react';
import { useProgramsInfiniteQuery } from '../../../queries';
import type { ProgramsListFilter } from '../../../types';

// TODO: rename
export const usePrograms = ({
  allowUnfeatured,
  filter,
  pagination,
}: {
  allowUnfeatured?: boolean;
  filter?: ProgramsListFilter;
  pagination: Omit<Pagination, 'position'>;
}) => {
  const [isFeatured, setIsFeatured] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
    setIsFeatured(true);
  }, [filter?.organizationId]);

  const query = useProgramsInfiniteQuery({
    filter: { featured: isFeatured, ...filter },
    pagination,
  });

  useEffect(() => {
    if (isFeatured && allowUnfeatured && query.data?.pages[0]?.data.length === 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
      setIsFeatured(false);
    }
  }, [isFeatured, allowUnfeatured, query.data?.pages]);

  return { isFeatured, query };
};
